import React from "react";

const AboutStarterCards = ({ card, index }) => {
  const isEven = index % 2 === 0;

  return (
    <div className="container py-5">
      <div className="row justify-content-center d-none d-md-flex">
        {/* First Section (Image or Text depending on the sequence) */}
        <div
          className={`col-12 col-md-4 d-flex justify-content-between align-items-center ${
            isEven ? "order-1" : "order-1"
          }`}
        >
          {isEven ? (
            <div
              className={`makeInnerH2Golden d-flex flex-column justify-content-${
                isEven ? "end" : "start"
              } align-items-start`}
              dangerouslySetInnerHTML={{ __html: card.description }}
            ></div>
          ) : (
            <img
              src="/assets/images/admin_9.jpg"
              //   src={card.image}
              //   alt={card.header}
              style={{ width: "100%", maxWidth: "400px", borderRadius: "8px" }}
            />
          )}
        </div>

        {/* Second Section (Number) */}
        <div
          style={{ paddingRight: isEven ? "0px" : "5rem" }}
          className={`col-12 col-md-4 d-flex align-items-center ${
            isEven
              ? "order-2 justify-content-center"
              : "order-3 justify-content-end"
          }`}
        >
          <div
            className="number-box d-flex justify-content-center align-items-center"
            style={{
              width: "60px",
              height: "60px",
              color: "#FCD8BA",
              fontSize: "5rem",
              fontWeight: "bold",
            }}
          >
            {card.title}
          </div>
        </div>

        {/* Third Section (Text or Image depending on the sequence) */}
        <div
          className={`col-12 col-md-4 d-flex align-items-center ${
            isEven
              ? "order-3 justify-content-end"
              : "order-2 justify-content-start"
          }`}
        >
          {isEven ? (
            <img
              src="/assets/images/admin_9.jpg"
              //   src={card.image}
              //   alt={card.header}
              style={{ width: "100%", maxWidth: "400px", borderRadius: "8px" }}
            />
          ) : (
            <div
              className="makeInnerH2Golden d-flex flex-column justify-content-center align-items-start"
              dangerouslySetInnerHTML={{ __html: card.description }}
            ></div>
          )}
        </div>
      </div>

      {/* Mobile and Tablet View */}
      <div className="row d-flex d-md-none gap-4">
        <div
          className={`col-12 number-box d-flex align-items-center justify-content-between ${
            isEven ? "order-0" : "order-1"
          } gap-4`}
        >
          <div
            className={`d-flex align-items-center justify-content-center ${
              isEven ? "order-0" : "order-1"
            } `}
            style={{
              width: "60px",
              height: "60px",
              color: "#FCD8BA",
              fontSize: "5rem",
              fontWeight: "bold",
            }}
          >
            {card.title}
          </div>
          <div className="">
            <img
              src="/assets/images/admin_9.jpg"
              style={{ width: "100%", maxWidth: "300px", borderRadius: "8px" }}
            />
          </div>
        </div>
        <div
          className={`makeInnerH2Golden col-12 d-flex flex-column ${
            isEven ? "align-items-start" : "align-items-end"
          }`}
          dangerouslySetInnerHTML={{ __html: card.description }}
        ></div>
      </div>
    </div>
  );
};

export default AboutStarterCards;



// WEBPACK FOOTER //
// ./src/component/frontend/AboutStarterCards.js